module.exports = __webpack_public_path__ + "static/media/total_centro_estudo.cb3c27f5.jpg";